module.exports = __webpack_public_path__ + "img/MT.8e8ffcff.svg";